import { Box, useStyleConfig } from '@chakra-ui/react';
import type { FC } from 'react';

import type { CaptionProps } from './types';

export const Caption: FC<CaptionProps> = ({ variant, children, ...props }) => {
  const styles = useStyleConfig('Caption', { variant });
  return (
    <Box as="p" __css={styles} {...props}>
      {children}
    </Box>
  );
};

export * from './constants';
export * from './styleConfig';
export * from './types';
